import { render } from "./TaskList.vue?vue&type=template&id=2ad23e74&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"

import "./TaskList.vue?vue&type=style&index=0&id=2ad23e74&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad23e74"],['__file',"src/views/qywx/crm/project/TaskList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ad23e74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ad23e74', __exports__)) {
    api.reload('2ad23e74', __exports__)
  }
  
  module.hot.accept("./TaskList.vue?vue&type=template&id=2ad23e74&scoped=true", () => {
    api.rerender('2ad23e74', render)
  })

}


export default __exports__